import { regex } from 'vuelidate/lib/validators/common'

export default regex('name', /^[a-zA-Z][a-zA-Z\s']*$/)



// WEBPACK FOOTER //
// ./src/common/nameValidator.js